import { render, staticRenderFns } from "./ButtonEdit.vue?vue&type=template&id=580879cb&scoped=true"
import script from "./ButtonEdit.vue?vue&type=script&lang=js"
export * from "./ButtonEdit.vue?vue&type=script&lang=js"
import style0 from "./ButtonEdit.vue?vue&type=style&index=0&id=580879cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580879cb",
  null
  
)

export default component.exports